/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_ContactInputs */

const en_privacy_section_2_item_contact = /** @type {(inputs: Privacy_Section_2_Item_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact form submissions`)
};

const lv_privacy_section_2_item_contact = /** @type {(inputs: Privacy_Section_2_Item_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktformas iesniegumi`)
};

/**
* | output |
* | --- |
* | "Contact form submissions" |
*
* @param {Privacy_Section_2_Item_ContactInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_contact = /** @type {((inputs?: Privacy_Section_2_Item_ContactInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_ContactInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_contact(inputs)
	return en_privacy_section_2_item_contact(inputs)
});